"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon"));

require("../styles/_breadcrumbs.scss");

var _Text = _interopRequireDefault(require("../../Text")),
    _reactRouterDom = require("react-router-dom"),
    renderBreadCrumbLink = function renderBreadCrumbLink(a, b) {
  return _react["default"].createElement(_reactRouterDom.Link, {
    className: (0, _classnames["default"])("breadcrumbs__breadcrumb__link", {
      "breadcrumbs__breadcrumb__link--dark-mode": b
    }),
    to: a.url
  }, _react["default"].createElement(_Text["default"], {
    placeholder: !0,
    noMargin: !0,
    darkTheme: b
  }, a.title));
};

function BreadCrumbs(a) {
  var b = a.items,
      c = a.darkMode;
  return _react["default"].createElement("ul", {
    className: "breadcrumbs"
  }, b.map(function (a, d) {
    return a.url ? _react["default"].createElement("li", {
      key: a.url,
      className: "breadcrumbs__breadcrumb"
    }, renderBreadCrumbLink(a, !!c), d === b.length - 1 ? null : _react["default"].createElement(_Icon["default"], {
      name: "chevronright",
      color: c ? "white" : "regent",
      size: 10
    })) : null;
  }));
}

BreadCrumbs.displayName = "BreadCrumbs", BreadCrumbs.defaultProps = {
  darkMode: !1
};

var _default = (0, _react.memo)(BreadCrumbs);

exports["default"] = _default;